export const loadingPlaceholder = "rPRrR";
export default {loadingPlaceholder};